import { FileUtils } from "../../../../../common/utils/file_utils";
import { ICreateFuncionarioUseCase } from "../../../presentation/useCases/create/create_funcionario_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * CreateFuncionarioUseCase
 */

export class CreateFuncionarioUseCase implements ICreateFuncionarioUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) {
  }

  async createFuncionario(
    idCargo: number,
    idCentroCusto: number,
    nome: string,
    sexo: string,
    dataAdmissao: Date,
    regime: string | null,
    dataNascimento: Date | null,
    idMotivoDemissao: number | null,
    dataDemissao: Date | null,
    setor: string | null,
    avaliarHabilidadesEm: number | null,
    descontoSindical: number | null,
    filial: string | null,
    email1: string | null,
    email2: string | null,
    matricula: string | null,
    telefoneMovel: string | null,
    telefoneFixo: string | null,
    horarioTrabalho: string | null,
    horarioAlmoco: string | null,
    nacionalidade: string | null,
    naturalidade: string | null,
    estado: string | null,
    cpf: string | null,
    numeroPis: string | null,
    estadoCivil: string | null,
    salario: number | null,
    periodo: string | null,
    experiencia: number | null,
    prorrogarEm: number | null,
    aprovadoExperiencia: number | null,
    escolaridade: string | null,
    cargaHorarioMensal: string | null,
    valeTransporte: number | null,
    valorValeTransporte: number | null,
    ctps: string | null,
    ctpsSerie: string | null,
    ctpsEstado: string | null,
    ctpsDataEmissao: Date | null,
    rg: string | null,
    rgDataExped: Date | null,
    rgOrgaoExped: string | null,
    rgEstado: string | null,
    tituloEleitor: string | null,
    tituloZona: string | null,
    tituloSecao: string | null,
    reservista: string | null,
    nomeMae: string | null,
    nomePai: string | null,
    conjugeNome: string | null,
    conjugeRg: string | null,
    conjugeCpf: string | null,
    complementoCamisaInfo: string | null,
    complementoCalcaInfo: string | null,
    complementoCalcadoInfo: string | null,
    enderecoCep: string | null,
    enderecoCidade: string | null,
    enderecoEndereco: string | null,
    enderecoNumero: string | null,
    enderecoComplemento: string | null,
    enderecoBairro: string | null,
    enderecoEstado: string | null,
    enderecoPais: string | null,
    bancTipoInfo: number | null,
    bancBancoInfo: string | null,
    bancAgenciaInfo: string | null,
    bancContaInfo: string | null,
    bancContaDigitoInfo: string | null,
    bancOperacaoInfo: string | null,
    bancPixInfo: string | null,
    observacaoGeral: string | null,
    observacaoDocumento: string | null,
    demissaoData: Date | null,
    inicioAvisoPrevio: Date | null,
    fimAvisoPrevio: Date | null,
    file: File | null,
    horarioTrabalhoSegQui: string | null,
    horarioTrabalhoSex: string | null,
  ): Promise<number> {
    return await this.repository.createFuncionario({
      idFuncionario: 0,
      idCargo: idCargo,
      idCentroCusto: idCentroCusto,
      nome: nome,
      sexo: sexo,
      regime: regime,
      dataNascimento: dataNascimento,
      dataAdmissao: dataAdmissao,
      idMotivoDemissao: idMotivoDemissao,
      dataDemissao: dataDemissao,
      setor: setor,
      avaliarHabilidadesEm: avaliarHabilidadesEm,
      descontoSindical: descontoSindical,
      filial: filial,
      email1: email1,
      email2: email2,
      matricula: matricula,
      telefoneMovel: telefoneMovel,
      telefoneFixo: telefoneFixo,
      horarioTrabalho: horarioTrabalho,
      horarioAlmoco: horarioAlmoco,
      nacionalidade: nacionalidade,
      naturalidade: naturalidade,
      estado: estado,
      cpf: cpf,
      numeroPis: numeroPis,
      estadoCivil: estadoCivil,
      salario: salario,
      periodo: periodo,
      experiencia: experiencia,
      prorrogarEm: prorrogarEm,
      aprovadoExperiencia: aprovadoExperiencia,
      escolaridade: escolaridade,
      cargaHorarioMensal: cargaHorarioMensal,
      valeTransporte: valeTransporte,
      valorValeTransporte: valorValeTransporte,
      ctps: ctps,
      ctpsSerie: ctpsSerie,
      ctpsEstado: ctpsEstado,
      ctpsDataEmissao: ctpsDataEmissao,
      rg: rg,
      rgDataExped: rgDataExped,
      rgOrgaoExped: rgOrgaoExped,
      rgEstado: rgEstado,
      tituloEleitor: tituloEleitor,
      tituloZona: tituloZona,
      tituloSecao: tituloSecao,
      reservista: reservista,
      nomeMae: nomeMae,
      nomePai: nomePai,
      conjugeNome: conjugeNome,
      conjugeRg: conjugeRg,
      conjugeCpf: conjugeCpf,
      complementoCamisaInfo: complementoCamisaInfo,
      complementoCalcaInfo: complementoCalcaInfo,
      complementoCalcadoInfo: complementoCalcadoInfo,
      enderecoCep: enderecoCep,
      enderecoCidade: enderecoCidade,
      enderecoEndereco: enderecoEndereco,
      enderecoNumero: enderecoNumero,
      enderecoComplemento: enderecoComplemento,
      enderecoBairro: enderecoBairro,
      enderecoEstado: enderecoEstado,
      enderecoPais: enderecoPais,
      bancTipoInfo: bancTipoInfo,
      bancBancoInfo: bancBancoInfo,
      bancAgenciaInfo: bancAgenciaInfo,
      bancContaInfo: bancContaInfo,
      bancContaDigitoInfo: bancContaDigitoInfo,
      bancOperacaoInfo: bancOperacaoInfo,
      bancPixInfo: bancPixInfo,
      observacaoGeral: observacaoGeral,
      observacaoDocumento: observacaoDocumento,
      demissaoData: demissaoData,
      inicioAvisoPrevio: inicioAvisoPrevio,
      fimAvisoPrevio: fimAvisoPrevio,
      documentosEntregues: null,
      imagem: file,
      hasProfileImage: false,
      horarioTrabalhoSegQui: horarioTrabalhoSegQui,
      horarioTrabalhoSex: horarioTrabalhoSex,
    });
  }
}